<span class="inner" [ngClass]="{ close }">
  <span class="line"></span>
  <span class="line"></span>
  <span class="line"></span>
</span>
